// extracted by mini-css-extract-plugin
export default {"container":"Error_page_container__wXld+","wrapper":"Error_page_wrapper__GHntw","close":"Error_page_close__rpbMS","userIcon":"Error_page_userIcon__4cauA"};